'use client'
import { useUser } from '@/app/context/UserContext';
import { iMyDocFileData } from '@/app/models/interfaceMyDocFileData';
import { chatbotMyDocs } from '@/app/services/chatbotmydocs';
import { chatbotMyDocsFileData, chatbotMyDocsFileDataUpdate } from '@/app/services/chatbotMyDocsFileData';
import { CircleCheckBig, Paperclip, UploadIcon } from 'lucide-react';
import React, { useEffect, useRef, useState } from 'react';
import ReactDOM from "react-dom";
import Loading from '../Elements/Loading';
import InputChat from '../Elements/Core/InputChat';
import { Action, TypeFile } from '@/app/constants/enums';
import TextareaChat from '../Elements/Core/TextareaChat';
import ButtonChat from '../Elements/Core/ButtonChat';

interface UploadModalProps {
  isOpen: boolean;
  onClose: () => void;
  myDoc:iMyDocFileData| null;
}

interface ErrorMessages {
    filename: string;
    name: string;
    description: string;
  }

const UploadModal: React.FC<UploadModalProps> = ({ isOpen, onClose, myDoc }:UploadModalProps) => {
  const [isUploading, setIsUploading] = useState(false);
  const [isSaveError, setIsSaveError] = useState(false);
  const [isSaveSucces, setIsSaveSucces] = useState(false);
  const { user, setUser, userProject,setUserProject, myDocs, setMyDocs } = useUser();// Accedemos al usuario logueado desde el contexto
  const [fileData, setFileData] = useState<iMyDocFileData>({
    file_id:'0',  
    filename: '',
      name: '',
      description: '',
      type: TypeFile.Pdf,
      //file: null,
  });

  useEffect(() => {
    const startFrm=()=>{ 
        if(myDoc!=null){ 
          setFileData({
            file_id:myDoc.file_id,
            filename: myDoc.filename,
            name: myDoc.name,
            description: myDoc.description,
            type: TypeFile.Pdf,
          }); 
        } 
      }  
      startFrm(); 
  }, [myDoc]); 
  const [errors, setErrors] = useState<ErrorMessages>({
      filename: '',
      name: '',
      description: '',
    });

  const handleModalClose = () => {
      setFileData({
          file_id:'0',
          filename: '',
          name: '',
          description: '',
          type: TypeFile.Pdf,
          // file: null,
        });
        setErrors({ filename: '', name: '', description: '' });
        setIsUploading(false);
        setIsSaveError(false);
        setIsSaveSucces(false);
        onClose();
    };

  const validateFields = () => {
      const newErrors: ErrorMessages = {
          filename: fileData.filename ? '' : 'Archivo requerido',
          name: fileData.name ? '' : 'Nombre requerido',
          description: fileData.description ? '' : 'Descripción requerida',
      };
      setErrors(newErrors);
      return !Object.values(newErrors).some(error => error);
  };

  const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      if (file.type === "application/pdf") {
        setFileData({
            ...fileData,
            filename: file.name,
            file: file,
          });  
          setErrors({ ...errors, filename: '' });
      } else {
        setFileData({
            ...fileData,
            filename: "",
            //file: null,
          }); 
         setErrors({ ...errors, filename: 'Solo se permiten archivos PDF' });
      }
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = e.target;
    setFileData({
      ...fileData,
      [name]: value,
    });
    setErrors({ ...errors, [name as keyof ErrorMessages]: value ? '' : errors[name as keyof ErrorMessages] });
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
     
    if (!validateFields()) return;

    const saveFileMyDoc = async () => {  
        setIsUploading(true);
          try { 

            if(myDoc == null){
              const response = await chatbotMyDocsFileData([fileData],user,setUser);   
              if(response.success && response.code == 200){ 
                  setIsSaveSucces(true); 
                  setIsUploading(false);
                  const response = await chatbotMyDocs(user,setUser);   
                  if(response.success && response.code == 200){  
                    setMyDocs(response.data);

                    await new Promise((resolve) => setTimeout(resolve, 3000));                  
                    handleModalClose(); 
                  }
              }else{
                setIsSaveError(true);
              }
            }else{
              const response = await chatbotMyDocsFileDataUpdate(fileData,user,setUser);   
              if(response.success && response.code == 200){ 
                  setIsSaveSucces(true); 
                  setIsUploading(false);
                  const response = await chatbotMyDocs(user,setUser);   
                  if(response.success && response.code == 200){ 
                    setMyDocs(response.data); 


                    await new Promise((resolve) => setTimeout(resolve, 3000));                  
                    handleModalClose(); 
                  }
              }else{
                setIsSaveError(true);
              }
            } 
          } catch (error) { 
            setIsSaveError(true);
            console.error("Error al cargar",error) 
          } finally { 
            setIsUploading(false); 
          }
      } 
      saveFileMyDoc(); 
  };

  const inputRef = useRef<HTMLInputElement | null>(null); // Define tipo explícitamente
  const handleButtonClick = () => {
    if (inputRef.current) {
      inputRef.current.click(); // Ejecuta el click solo si inputRef.current no es null
    }
  };
 

  if (!isOpen) return null;


  return ReactDOM.createPortal(
    <div className="fixed inset-0 bg-gray-800 bg-opacity-50 flex items-center justify-center z-20">
      <div className={`bg-white rounded-lg n-card-modal shadow-lg pl-6 pr-6 pb-3 pt-0 w-3/5 ${isOpen ? 'animate-fadeIn' : 'animate-fadeOut'} `}>
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Mis Fuentes</h2>
          <button onClick={handleModalClose} 
            className="text-gray-500 hover:text-gray-700 text-5xl"
            >&times;</button>
        </div>
        <h3 className="text-lg font-semibold mb-1">Agrega fuente</h3>
        <p className="text-sm text-gray-500 mb-4">Las fuentes permiten que PlayGround base sus respuestas...</p>
        
        <form onSubmit={handleSubmit}> 
          <div className="border-dashed rounded-3xl border-2 border-gray-300 p-6 text-center mb-4 flex flex-col items-center justify-center">
                <label className="flex items-center cursor-pointer"> 
                  <InputChat
                      actionCode={Action.LEFT_MY_DOC_ADD_FILE} 
                      type="file"
                      onChange={handleFileChange}
                      accept=".pdf"
                      disabled={isUploading}
                      className="hidden" 
                      ref={inputRef}
                    />
                <button
                    type="button"
                    disabled={isUploading || myDoc!=null} 
                    onClick={handleButtonClick}
                    className="flex items-center border rounded-full disabled:bg-gray-300 transition duration-200 ease-in-out bg-gray-100 hover:bg-gray-400 bag p-3 focus:outline-none focus:ring-1 focus:ring-blue-700"
                >
                    <Paperclip className="w-5 h-5 mr-2" />
                    <span className="flex items-center">
                        {isUploading ? 'Subiendo...' : (myDoc!=null?'Disabled':'Seleccionar archivo')}
                    </span>
                </button>
            </label>
            {errors.filename && <p className="text-red-600 text-sm mt-2">{errors.filename}</p>}
            {fileData.filename && (
                <p className="text-gray-600 text-base font-semibold truncate max-w-xs">
                {fileData.filename}
                </p>
            )}
             
            {/*<p className="text-blue-600">Arrastra y suelta o elige un archivo para subirlo</p>*/}
            <p className="text-sm text-gray-500">Tipos de archivos admitidos: PDF</p>
          </div>

          <div className="mb-4">
            <label className="block text-gray-700">Nombre</label> 
            <InputChat
              actionCode={Action.LEFT_MY_DOC_ADD_NAME} 
              type="text"
              name="name"
              onChange={handleChange}
              value={fileData.name}
              disabled={isUploading}
              className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
              placeholder="Nombre"
            />
            {errors.name && <p className="text-red-600 text-sm mt-2">{errors.name}</p>}
          </div>
          <div className="mb-4">
            <label className="block text-gray-700">Descripción</label>
            <TextareaChat
              actionCode={Action.LEFT_MY_DOC_ADD_DESCRIPTION} 
              name="description"
              onChange={handleChange}
              value={fileData.description}
              disabled={isUploading}
              className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
              placeholder="Descripción"
            />
            {errors.description && <p className="text-red-600 text-sm mt-2">{errors.description}</p>}
          </div>
          
            
          <div className="col-span-2 flex justify-end mt-4"> 
            {(isUploading && (!isSaveSucces || !isSaveError))&& ( 
              <div className="flex items-center justify-center">
                  <Loading w="w-2" h="h-2" className="ml-auto"/>
              </div> 
            )}

            {(!isUploading && !isSaveSucces && !isSaveError) && ( 
              <div className="flex items-center justify-center"> 
                  <ButtonChat
                      actionCode={Action.LEFT_MY_DOC_ADD_CANCEL}
                      type="button"
                      onClick={handleModalClose}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700  py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                      >
                      Cancelar
                      </ButtonChat>
                      <ButtonChat
                        actionCode={Action.LEFT_MY_DOC_ADD_SAVE}
                        type="submit"
                        className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                      >
                      Guardar
                      </ButtonChat>
              </div>
            )} 
            {isSaveSucces && (              
              <div className="flex items-center justify-center">
                  <div className="flex items-center justify-center mr-2">
                    <CircleCheckBig className="w-8 h-8 text-green-500"/> 
                  </div>
                  <ButtonChat
                      actionCode={Action.LEFT_MY_DOC_ADD_CLOSE}
                      type="button"
                      onClick={handleModalClose}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                      >
                      Cerrar
                  </ButtonChat> 
              </div>
            )}
            {isSaveError && (              
              <div className="flex items-center justify-center">
                  <div className="flex items-center justify-center text-red-500 mr-2">                    
                    Error uploading
                  </div>
                  <ButtonChat
                      actionCode={Action.LEFT_MY_DOC_ADD_CLOSE}
                      onClick={handleModalClose}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700 py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                      >
                      Cerrar
                  </ButtonChat> 
              </div>
            )}
            
          </div>
           
        </form>
      </div>
    </div>
    , document.body // El modal se renderiza aquí
  );
};

export default UploadModal;
